import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { GenericProgressBar } from "../../../components/GenericProgressBar";

const propTypes = {
  /**
   * Number of configured postures
   */
  configured: PropTypes.number,
  /**
   * Number of partially configured postures
   */
  partiallyConfigured: PropTypes.number,
  /**
   * Number of not configured postures
   */
  notConfigured: PropTypes.number,
  /**
   * Number of resolved postures
   */
  resolved: PropTypes.number,
  /**
   * Number of not measured postures
   */
  notMeasured: PropTypes.number,
  /**
   * If true, shows title
   */
  showTitle: PropTypes.bool,
  /**
   * If true, shows legend footer
   */
  showLegendFooter: PropTypes.bool
};











const colors = [
"var(--aug-status-compliant)",
"var(--aug-status-partial)",
"var(--aug-status-noncompliant)",
"var(--aug-status-resolved)",
"var(--aug-risk-legend-info)"];


function PostureComplianceStatus(props) {
  const {
    configured = 0,
    partiallyConfigured = 0,
    notConfigured = 0,
    resolved = 0,
    notMeasured = 0,
    showTitle = true,
    showLegendFooter = true
  } = props ?? {};
  const intl = useIntl();

  const labels = useMemo(() => [
  intl.formatMessage({ id: "SECURE.POSTURE.CONFIGURED" }),
  intl.formatMessage({
    id: "SECURE.POSTURE.PARTIALLY_CONFIGURED"
  }),
  intl.formatMessage({
    id: "SECURE.POSTURE.NOT_CONFIGURED"
  }),
  intl.formatMessage({ id: "SECURE.POSTURE.RESOLVED" }),
  intl.formatMessage({ id: "SECURE.POSTURE.NOT_MEASURED" })],
  [intl]);
  const values = useMemo(() => [
  configured,
  partiallyConfigured,
  notConfigured,
  resolved,
  notMeasured],
  [configured, partiallyConfigured, notConfigured, resolved, notMeasured]);

  return (
    <GenericProgressBar
      title={showTitle ? "SECURE.COMPLIANCE_STATUS" : undefined}
      values={values}
      valueLabels={labels}
      colors={colors}
      showLegendFooter={showLegendFooter}
      flexGrow={8}
      isMultiValueProgressBar />);


}

PostureComplianceStatus.propTypes = propTypes;


export default PostureComplianceStatus;
